import { ROUTE } from "../../routes";
import { isMobile, openInvestorLinkWhatsApp, openInvestorLinkWhatsAppOnPhone, openUserLinkWhatsApp, openUserLinkWhatsAppOnPhone } from "../../configs/utils";
import { StoreKey } from "../../configs/api";
export const CopyLink = async (action, _datastore, { clipboard, setDatastore, instrumentTrack }) => {
    console.warn('**** CopyLink Action Triggered ****', action);
    instrumentTrack("INVITE_CLIENT_INITIATED", {
        "type": "copy_link"
    });
    clipboard.set(action.payload.value);
    await setDatastore(ROUTE.INVITE_CLIENT, 'copyText', {
        label: 'Copied'
    });
    setTimeout(async () => {
        await setDatastore(ROUTE.INVITE_CLIENT, 'copyText', {
            label: 'Copy'
        });
    }, 1000);
};
export const InviteViaWhatsapp = async (action, _datastore, { asyncStorage, instrumentTrack }) => {
    console.warn('**** InviteViaWhatsapp Action Triggered ****', action);
    instrumentTrack("INVITE_CLIENT_INITIATED", {
        "type": "WhatsApp"
    });
    const link = action.payload.value;
    const interestRate = action?.payload?.interestRate;
    const customer = action?.payload?.customer;
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const interestRateText = `${interestRate}%`;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerName = user?.linkedPartnerAccounts[0].partnerName;
    const _isMobile = isMobile();
    if (!_isMobile) {
        if (currentActiveTabIndex >= 1)
            openUserLinkWhatsApp(interestRateText, link, partnerName, customer, currentActiveTabIndex);
        else
            openInvestorLinkWhatsApp(interestRateText, link, partnerName);
    }
    else {
        if (currentActiveTabIndex >= 1)
            openUserLinkWhatsAppOnPhone(interestRateText, link, partnerName, customer, currentActiveTabIndex);
        else
            openInvestorLinkWhatsAppOnPhone(interestRateText, link, partnerName);
    }
};
export const CloseInvite = async (action, _datastore, { hidePopup, navigate }) => {
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const currentPage = action?.payload?.currentPage;
    const filterObj = action?.payload?.filterObj;
    const numberOfFilterApplied = action?.payload?.numberOfFilterApplied;
    const currentPendingCustomerActiveTabIndex = action?.payload?.currentPendingCustomerActiveTabIndex;
    const searchContext = action?.payload?.searchContext;
    if (currentPendingCustomerActiveTabIndex >= 1) {
        await navigate(ROUTE.PARTNER_LEAD, {
            currentPendingCustomerActiveTabIndex,
            currentPage,
            searchContext,
        });
    }
    else if (currentActiveTabIndex >= 1) {
        await navigate(ROUTE.PARTNER_ACTIVE_CUSTOMER, {
            currentActiveTabIndex,
            filterObj,
            numberOfFilterApplied,
        });
    }
    else
        await hidePopup();
};
